var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"step-container"},[_c('el-steps',{attrs:{"active":_vm.isActive,"align-center":""}},_vm._l((_vm.stepList),function(item){return _c('el-step',{key:item.id,attrs:{"title":item.title,"description":item.description ? item.description : ''}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }